import React, { useEffect } from 'react';
import disposableDomains from 'disposable-email-domains';

const HsForm = ({ formId }) => {
  useEffect(() => {
    const MAX_ATTEMPTS = 60;
    let hubspotScript = null;

    const initHubspot = () => {
      let formCheckAttempts = 0;

      const tryInitForm = () => {
        const formTarget = document.querySelector('#hubspotForm');
        if (!formTarget) {
          if (formCheckAttempts++ >= MAX_ATTEMPTS) {
            console.warn('HubSpot form container not found after max attempts');
            return;
          }
          setTimeout(tryInitForm, 50);
          return;
        }

        if (!window.hbspt) {
          console.warn('HubSpot library not loaded');
          return;
        }

        window.hbspt.forms.create({
            region: 'na1',
            portalId: '8853360',
            formId,
            target: '#hubspotForm',
          
            onFormReady: ($form) => {
              const honeypot = document.createElement('input');
              honeypot.type = 'text';
              honeypot.name = 'website';
              honeypot.style.position = 'absolute';
              honeypot.style.left = '-9999px';
              honeypot.setAttribute('aria-hidden', 'true');
              $form.appendChild(honeypot);
            },
          
            onFormSubmit: async ($form) => {
              const emailInput = $form.querySelector('input[name="email"]');
              const email = emailInput?.value;
              const domain = email?.split('@')[1];
              const honeypot = $form.querySelector('input[name="website"]');
          
              if (honeypot?.value) {
                alert('Bot submission detected.');
                e.preventDefault();
                return;
              }
          
              if (disposableDomains.includes(domain)) {
                alert('Please use a non-disposable email address.');
                e.preventDefault();
                return;
              }
          
              // Simulated or real API call
              const result = {
                is_valid_format: true,
                is_disposable_email: false,
                mx_found: true,
                deliverability: 'DELIVERABLE',
              };
          
              if (
                !result.is_valid_format ||
                result.is_disposable_email ||
                !result.mx_found ||
                result.deliverability === 'UNDELIVERABLE'
              ) {
                alert('This email address appears invalid or undeliverable.');
                e.preventDefault();
              }
          
              // ✅ All checks passed, allow submission
              return true;
            },
          });
          
      };

      tryInitForm();
    };

    // Inject the HubSpot script
    hubspotScript = document.createElement('script');
    hubspotScript.src = 'https://js.hsforms.net/forms/shell.js';
    hubspotScript.async = true;
    hubspotScript.onload = initHubspot;
    document.body.appendChild(hubspotScript);

    // Cleanup on unmount
    return () => {
      if (hubspotScript && hubspotScript.parentNode) {
        hubspotScript.parentNode.removeChild(hubspotScript);
      }
    };
  }, [formId]);

  return <div id="hubspotForm"></div>;
};

export default HsForm;
